export const PXCareersAjax = (function () {
	'use strict';

	function init() {
		const listEl = document.querySelector('[data-careers-ajax]')
		const data = {}
		if (!listEl) {
			return
		}

		const onData = (resp) => {
			resp.forEach((listing) => {
				listEl.innerHTML += `
					<a href="${window.location.origin}/job/${listing.slug}/" data-scroll-animator="fadeIn,0.5,1,0.9">
						<h4>${listing.title}</h4>
						<p>${listing.excerpt}</p>
					</a>
				`
				data[listing.slug] = {
					title: listing.title,
					content: listing.content
				}
			})
			window.dispatchEvent(new Event('px-content-added'))
		}
		$.getJSON(`/wp-content/themes/rmi/jobs-ajax.php`, onData)

	}

	return {
		init: init
	};
})();
